import { cn } from "@/core/helpers/cn";
import { MicOffIcon, MicOnIcon } from "@/shared/icons";

type Props = {
  className?: string;
  on: boolean;
};

export default function SpeakingIndicator({ className, on }: Props) {
  return (
    <div
      className={cn(
        "flex items-center justify-center w-[2.625rem] aspect-square bg-dark-900/60 rounded-[0.5rem]",
        className,
      )}
    >
      {on ? (
        <MicOnIcon size={20} className="text-white" />
      ) : (
        <MicOffIcon size={20} className="text-white" />
      )}
    </div>
  );
}
